<div class="row ">

    <span class="float-right ml-auto" style="margin-right: 85px;" *ngIf="hasPermission">
        <button class="ml-2 btn btn-browse" type="button" (click)="addDisclaimer()">Add Disclaimer</button>
    </span>

</div>
<div class="col-md-12 mt-2">
    <div class="row" *ngFor="let alert of alerts" class="padding-b-15">
        <div class="alert alert-dismissible" [ngClass]="{'alert-danger': alert.type === 'error','alert-success': alert.type === 'success'}">
            <button type="button" class="close" data-dismiss="alert" (click)="closeAlerts()">×</button>
            {{ alert.msg }}
        </div>
    </div>
</div>
<div class="col-md-12">
    <div *ngIf="disclaimers">
        <div *ngFor="let disclaimer of disclaimers">
            <span class="card ">
                <div class="card-block">
                    <div class="card-body text-center">
                        <div class="row col-md-12">
                            <div class="col-md-4 disclaimer-content">{{disclaimer.disclaimer.disclaimerId}}. {{disclaimer.disclaimer.disclaimerTitle}}</div>
                            <div class="col-md-6 disclaimer-content">{{disclaimer.disclaimer.disclaimerMessage}}</div>
                            <span class="action-control col-md-2">
                                <a *ngIf="hasPermission" class="action-control-delete" (click)="editDisclaimer(disclaimer) ">
                                    <img alt="Edit" [src]="commonService.commonFiles['edit']">
                                </a>
                            </span>
                        </div>
                    </div>
                </div>
            </span>
        </div>
    </div>
</div>